import React from 'react';
import { Route, Switch } from 'react-router';

import { ProdStackManagerAsyncFallback } from 'containers/ProdStackManager/ProdStackManagerAsyncFallback';
import { PartnerRegistrationManagerAsyncFallback } from 'containers/PartnerRegistrationManager/PartnerRegistrationManagerAsyncFallback';
import { routes } from 'utils/routes';
import { DefaultAsyncFallback } from 'containers/DefaultAsyncFallback';

export const AppAsyncFallback = () => {
  return (
    <Switch>
      <Route path={routes.registrationProdPattern()}>
        <ProdStackManagerAsyncFallback />
      </Route>
      <Route path={routes.registrationPartnerPattern()}>
        <PartnerRegistrationManagerAsyncFallback />
      </Route>
      <Route path={routes.promocodePattern()}>
        <DefaultAsyncFallback noLogo />
      </Route>
      <Route path="/">
        <DefaultAsyncFallback />
      </Route>
    </Switch>
  );
};
